import { ArrowLeft, ArrowRight } from "lucide-react";
import { services } from "../../data/quoteData";
import Summary from "../components/Summary";

export default function Step4({data,setData,next,back}) {
  const selected = data.services || [];
  const toggle = (name) => setData({...data, services: selected.includes(name) ? selected.filter(x=>x!==name) : [...selected,name]});
  const total = services.filter(x=>selected.includes(x[0])).reduce((s,x)=>s+x[2],0);

  return (
    <div className="page-grid with-summary">
      <main className="form-card">
        <h2>4. Additional Services</h2>
        <p className="section-subtitle">Select any additional services you need. These services help make your move more convenient and worry-free.</p>
        <div className="service-grid">
          {services.map(([name,desc,price,icon]) => (
            <button className={"service-card " + (selected.includes(name) ? "selected":"")} onClick={()=>toggle(name)} key={name}>
              <div className="service-image">{icon}<span>{selected.includes(name) ? "✓" : ""}</span></div>
              <strong>{name}</strong><p>{desc}</p><b>₹ {price.toLocaleString("en-IN")}</b><small>Starting from</small>
            </button>
          ))}
        </div>
        <div className="custom-service">🎁 <div><strong>Need a Customized Service?</strong><span>Tell us your specific requirements and we'll be happy to help.</span></div><button>Request a Custom Service →</button></div>
        <div className="actions"><button className="back ghost" onClick={back}><ArrowLeft size={17}/> Back</button><button className="primary" onClick={next}>Next: Your Details <ArrowRight size={18}/></button></div>
      </main>
      <Summary data={data} total={total}/>
    </div>
  );
}
